module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleHomework
    }
  }, [_vm._v("\n\tCadastrar lição de casa para turma\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1f184a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/homework/create/create.vue
// module id = 1043
// module chunks = 1